import React, { Component } from "react";
import {
  Button, OverlayTrigger, Tooltip,
  Container, Col, Row, DropdownButton, Dropdown
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import WeekChart from '../charts/WeekChart';
import MonthChart from '../charts/MonthChart';
import YearChart from '../charts/YearChart';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "./Home.css";
import { API } from "aws-amplify";
import {
  getWeek, getMonth, getYear,
  startOfWeek, endOfWeek, startOfMonth,
  lastDayOfMonth, startOfYear, lastDayOfYear
} from "date-fns";
import { isNull, isUndefined } from "util";
import { FaCircleNotch } from 'react-icons/fa';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      weekNum: 0,
      mothNum: 0,
      year: 0,
      firstDay: "",
      lastDay: "",
      chartState: "week",
      leftBtnValid: true,
      sleepEntries: [],
      sleepQuality:
      {
        "id": "Quality",
        "color": "hsl(60, 70%, 50%)",
        "data": []
      },

      sleepDuration:
      {
        "id": "Hours",
        "color": "hsl(251, 71%, 54%)",
        "data": []
      },

      data: [],
      sleepDurationMax: 0,
      sleepDurationMin: 1000,
      sleepDurationAvg: 0,
      sleepQualityMax: 0,
      sleepQualityMin: 0,
      sleepQualityAvg: 0,
      monthNames: ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"],
    }
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }
    this.initializeDates();
    try {
      const sleepEntries = await this.getSleepEntries();
      this.sortSleepEntriesByDate(sleepEntries);
      this.setBorderDays(sleepEntries);
      this.setState({ sleepEntries });
      this.filterSleepEntriesByWeek(sleepEntries, this.state.weekNum);
      this.compileData();
    } catch (e) {
      alert(e);
    }

    this.setState({ isLoading: false });
  }

  initializeDates() {
    const currentDate = new Date();
    let weekNumber = getWeek(currentDate);
    this.setState({ weekNum: weekNumber });
    let monthNumber = getMonth(currentDate);
    this.setState({ monthNum: monthNumber });
    let yearNumber = getYear(currentDate);
    this.setState({ year: yearNumber });
  }

  compileData() {
    this.setState({ data: [] })
    this.state.data.push(this.state.sleepQuality);
    this.state.data.push(this.state.sleepDuration);
  }


  getSleepEntries() {
    return API.get("sleep", "/sleep/");
  }

  sortSleepEntriesByDate(input) {
    input.sort(
      (a, b) => {
        return new Date(a.sleepDate) - new Date(b.sleepDate);
      }
    )
  }

  setBorderDays(input) {
    let firstDay = this.adjustDateForChart(input[0].sleepDate);
    let lastDay = this.adjustDateForChart(input[input.length - 1].sleepDate);
    this.setState({ firstDay: firstDay });
    this.setState({ lastDay: lastDay });
  }

  resetData() {
    let updatedDuration = this.state;
    updatedDuration.sleepDuration.data = [];
    this.setState(updatedDuration);
    let updatedQuality = this.state;
    updatedQuality.sleepQuality.data = [];
    this.setState(updatedQuality);
  }

  adjustDateForChart(inputDate) {
    let adjustedDate = new Date(inputDate + "T00:00:00Z");
    adjustedDate.setDate(adjustedDate.getDate() + 1);
    return adjustedDate;
  }

  addToCurrentDataSet(sleepEntry) {
    let adjustedDate = this.adjustDateForChart(sleepEntry.sleepDate);
    this.state.sleepDuration.data.push({
      "x": adjustedDate,
      "y": sleepEntry.sleepDuration,
      "link": sleepEntry.logId
    })
    this.state.sleepQuality.data.push({
      "x": adjustedDate,
      "y": sleepEntry.sleepRating,
      "link": sleepEntry.logId
    })
  }

  filterSleepEntriesByYear(sleepEntries, yearNum) {
    this.resetData();
    let containsFirstDay = false;
    let containsLastDay = false;
    let sleepCount = 0;
    let durationMax = 0;
    let durationMin = 1000;
    let qualityMax = 0;
    let qualityMin = 1000;
    let durationAvgSum = 0;
    let qualityAvgSum = 0;
    let sampleDate = "";
    sleepEntries.forEach(sleepEntry => {
      if (getYear(new Date(sleepEntry.sleepDate + "T00:00:00")) === yearNum) {
        this.addToCurrentDataSet(sleepEntry);
        let entryDate = new Date(sleepEntry.sleepDate + "T00:00:00");
        let yearStart = startOfYear(new Date(sleepEntry.sleepDate + "T00:00:00"));
        containsFirstDay = this.compareDates(yearStart, entryDate);

        let lastday = lastDayOfYear(new Date(sleepEntry.sleepDate + "T00:00:00"));
        containsLastDay = this.compareDates(lastday, entryDate);

        durationMax = this.getDurationMax(sleepEntry, durationMax);
        durationMin = this.getDurationMin(sleepEntry, durationMin);
        qualityMax = this.getQualityMax(sleepEntry, qualityMax);
        qualityMin = this.getQualityMin(sleepEntry, qualityMin);

        sleepCount += 1;
        durationAvgSum += sleepEntry.sleepDuration;
        qualityAvgSum += parseInt(sleepEntry.sleepRating, 10);
        sampleDate = sleepEntry.sleepDate;
      }
    });
    this.addFilteredDataToSet(containsFirstDay, containsLastDay, sampleDate, "year");
    this.setState({ sleepDurationAvg: (durationAvgSum / sleepCount).toFixed(1) });
    this.setState({ sleepQualityAvg: (qualityAvgSum / sleepCount).toFixed(1) });
    this.setMinMaxState(durationMax, durationMin, qualityMax, qualityMin);
    this.setState({ chartState: "year" });
  }

  filterSleepEntriesByMonth(sleepEntries, monthNum) {
    this.resetData();
    let containsFirstDay = false;
    let containsLastDay = false;
    let sleepCount = 0;
    let durationMax = 0;
    let durationMin = 1000;
    let qualityMax = 0;
    let qualityMin = 1000;
    let durationAvgSum = 0;
    let qualityAvgSum = 0;
    let sampleDate = "";
    sleepEntries.forEach(sleepEntry => {
      if (getMonth(new Date(sleepEntry.sleepDate + "T00:00:00")) === monthNum) {
        this.addToCurrentDataSet(sleepEntry);
        let monthstart = startOfMonth(new Date(sleepEntry.sleepDate + "T00:00:00"));
        let entryDate = new Date(sleepEntry.sleepDate + "T00:00:00");
        containsFirstDay = this.compareDates(monthstart, entryDate);
        let lastday = lastDayOfMonth(new Date(sleepEntry.sleepDate + "T00:00:00"));
        containsLastDay = this.compareDates(lastday, entryDate);

        durationMax = this.getDurationMax(sleepEntry, durationMax);
        durationMin = this.getDurationMin(sleepEntry, durationMin);
        qualityMax = this.getQualityMax(sleepEntry, qualityMax);
        qualityMin = this.getQualityMin(sleepEntry, qualityMin);

        sleepCount += 1;
        durationAvgSum += sleepEntry.sleepDuration;
        qualityAvgSum += parseInt(sleepEntry.sleepRating, 10);
        sampleDate = sleepEntry.sleepDate;
      }
    });
    this.addFilteredDataToSet(containsFirstDay, containsLastDay, sampleDate, "month");
    this.setState({ sleepDurationAvg: (durationAvgSum / sleepCount).toFixed(1) });
    this.setState({ sleepQualityAvg: (qualityAvgSum / sleepCount).toFixed(1) });
    this.setMinMaxState(durationMax, durationMin, qualityMax, qualityMin);
    this.setState({ chartState: "month" });
  }

  filterSleepEntriesByWeek(sleepEntries, weekNum) {
    this.resetData();
    let containsFirstDay = false;
    let containsLastDay = false;
    let sleepCount = 0;
    let durationMax = 0;
    let durationMin = 1000;
    let qualityMax = 0;
    let qualityMin = 1000;
    let durationAvgSum = 0;
    let qualityAvgSum = 0;
    let sampleDate = (new Date(getYear(new Date()), 0, (1 + (weekNum - 1) * 7)));
    sleepEntries.forEach(sleepEntry => {
      if (getWeek(new Date(sleepEntry.sleepDate + "T00:00:00")) === weekNum) {
        this.addToCurrentDataSet(sleepEntry);
        let entryDate = new Date(sleepEntry.sleepDate + "T00:00:00");

        let weekstart = startOfWeek(new Date(sleepEntry.sleepDate + "T00:00:00"));
        containsFirstDay = this.compareDates(weekstart, entryDate);

        let weekend = endOfWeek(new Date(sleepEntry.sleepDate + "T00:00:00"));
        containsLastDay = this.compareDates(weekend, entryDate);

        durationMax = this.getDurationMax(sleepEntry, durationMax);
        durationMin = this.getDurationMin(sleepEntry, durationMin);
        qualityMax = this.getQualityMax(sleepEntry, qualityMax);
        qualityMin = this.getQualityMin(sleepEntry, qualityMin);

        sleepCount += 1;
        durationAvgSum += sleepEntry.sleepDuration;
        qualityAvgSum += parseInt(sleepEntry.sleepRating, 10);
        sampleDate = sleepEntry.sleepDate;
      }
    });
    this.addFilteredDataToSet(containsFirstDay, containsLastDay, sampleDate, "week");
    this.setState({ sleepDurationAvg: (durationAvgSum / sleepCount).toFixed(1) });
    this.setState({ sleepQualityAvg: (qualityAvgSum / sleepCount).toFixed(1) });
    this.setMinMaxState(durationMax, durationMin, qualityMax, qualityMin);
    this.setState({ chartState: "week" });
  }

  setMinMaxState(durationMax, durationMin, qualityMax, qualityMin) {
    this.setState({ sleepDurationMax: durationMax });
    this.setState({ sleepDurationMin: durationMin });
    this.setState({ sleepQualityMax: qualityMax });
    this.setState({ sleepQualityMin: qualityMin });
  }

  getDurationMax(sleepEntry, currentMax) {
    if (sleepEntry.sleepDuration > currentMax) {
      return sleepEntry.sleepDuration;
    }
    else {
      return currentMax;
    }
  }

  getDurationMin(sleepEntry, currentMin) {
    if (sleepEntry.sleepDuration < currentMin) {
      return sleepEntry.sleepDuration;
    }
    else {
      return currentMin;
    }
  }

  getQualityMax(sleepEntry, currentMax) {
    if (sleepEntry.sleepRating > currentMax) {
      return sleepEntry.sleepRating;
    }
    else {
      return currentMax;
    }
  }

  getQualityMin(sleepEntry, currentMin) {
    if (sleepEntry.sleepRating < currentMin) {
      return sleepEntry.sleepRating;
    }
    else {
      return currentMin;
    }
  }

  setQualityStats(sleepEntry) {
    if (sleepEntry.sleepRating > this.state.sleepQualityMax) {
      this.setState({ sleepQualityMax: sleepEntry.sleepRating });
    }
    if (sleepEntry.sleepRating < this.state.sleepQualityMin) {
      this.setState({ sleepQualityMin: sleepEntry.sleepRating })
    }
  }

  setDurationStats(sleepEntry) {
    if (sleepEntry.sleepDuration > this.state.sleepDurationMax) {
      this.setState({ sleepDurationMax: sleepEntry.sleepDuration });
    }
    if (sleepEntry.sleepDuration < this.state.sleepDurationMin) {
      this.setState({ sleepDurationMin: sleepEntry.sleepDuration })
    }
  }

  compareDates(weekStart, currentDate) {
    return weekStart.getDate() === currentDate.getDate();
  }

  addFilteredDataToSet(containsFirstDay, containsLastDay, sampleDate, range) {
    if (containsFirstDay === false && this.state.sleepDuration.data.length >= 0) {
      this.state.sleepDuration.data.push({
        "x": this.calculateXRangeStart(range, sampleDate),
        "y": null,
        "link": null
      });
      this.state.sleepQuality.data.push({
        "x": this.calculateXRangeStart(range, sampleDate),
        "y": null,
        "link": null
      });
    }
    if (containsLastDay === false && this.state.sleepDuration.data.length >= 0) {
      this.state.sleepDuration.data.push({
        "x": this.calculateXRangeEnd(range, sampleDate),
        "y": null,
        "link": null
      });
      this.state.sleepQuality.data.push({
        "x": this.calculateXRangeEnd(range, sampleDate),
        "y": null,
        "link": null
      });
    }
  }

  calculateXRangeStart(range, sampleDate) {
    switch (range) {
      case ("week"):
        return startOfWeek(new Date(sampleDate));
      case ("month"):
        return startOfMonth(new Date(sampleDate));
      case ("year"):
        return startOfYear(new Date(sampleDate));
      default:
        return startOfWeek(new Date(sampleDate));

    }
  }

  calculateXRangeEnd(range, sampleDate) {
    switch (range) {
      case ("week"):
        return endOfWeek(new Date(sampleDate));
      case ("month"):
        return lastDayOfMonth(new Date(sampleDate));
      case ("year"):
        return lastDayOfYear(new Date(sampleDate));
      default:
        return endOfWeek(new Date(sampleDate));

    }
  }

  renderLander() {
    return (
      <div className="lander">
        <h3>Track your sleep statistics with this modern sleep tracking application</h3>
        <p>Record sleep duration, sleep quality, notes and the number of times you woke up during the night. <br></br>
            Visualize your sleep duration and quality with an easy to use graph.
        </p>
        <div className="exampleGif">
          <img src={require('../media/example.gif')} alt="example gif of app"></img>
        </div>
        <LinkContainer to={`${process.env.PUBLIC_URL}/signup`}>
          <Button className="landerSignup">sign up</Button>
        </LinkContainer>
      </div>
    );
  }

  renderSleepEntries() {
    const chartState = this.state.chartState;
    const data = this.state.data;
    return (
      <div className="sleepEntries">
        <OverlayTrigger
          placement="left"
          delay={{ show: 450, hide: 100 }}
          overlay={
            <Tooltip>
              Click to create new entry
                  </Tooltip>
          }>
          <LinkContainer
            key="new"
            to={`${process.env.PUBLIC_URL}/sleepEntry/new`}
          >

            <h4 className="newEntry circle">
              {"\uFF0B"}
            </h4>

          </LinkContainer>
        </OverlayTrigger>
        <div>
          {this.renderSleepChart(chartState, data)}
          <Container>
            <Row>
              <Col>
                <OverlayTrigger
                  placement="left"
                  delay={{ show: 1250, hide: 100 }}
                  overlay={
                    <Tooltip>
                      Previous {this.state.chartState}
                    </Tooltip>
                  }>
                  <Button className="leftChartBtn" onClick={() => { this.leftClick() }} disabled={this.validLeftBtn()} >
                    <FiChevronLeft></FiChevronLeft>
                  </Button>
                </OverlayTrigger>
              </Col>
              <Col xs="auto">
                <DropdownButton
                  title={this.state.chartState}
                  className="timeRangeDropdown"
                >
                  <Dropdown.Item onClick={() => { this.weekClick() }}>Week</Dropdown.Item>
                  <Dropdown.Item onClick={() => { this.monthClick() }}>Month</Dropdown.Item>
                  <Dropdown.Item onClick={() => { this.yearClick() }}>Year</Dropdown.Item>
                </DropdownButton>
              </Col>
              <Col>
                <OverlayTrigger
                  placement="left"
                  delay={{ show: 1250, hide: 100 }}
                  overlay={
                    <Tooltip>
                      next {this.state.chartState}
                    </Tooltip>
                  }>
                  <Button className="rightChartBtn" onClick={() => { this.rightClick() }} /*disabled={this.validRightBtn()}*/ >
                    <FiChevronRight></FiChevronRight>
                  </Button>
                </OverlayTrigger>
              </Col>
            </Row>
          </Container>
          <div>
            <Container>
              <Row className="justify-content-md-center">

                <Col md="auto">
                  <Row>
                    <Col>
                      <h3 className="statHeaderHours">hours</h3>
                      <Row>
                        <Col className="statLabel">minimum</Col>
                        <Col className="statLabel">maximum</Col>
                        <Col className="statLabel">average</Col>
                      </Row>
                      {this.renderHoursValues()}
                    </Col>
                  </Row>
                </Col>

                <div className="colDivider"></div>

                <Col md="auto">
                  <Row>
                    <Col>
                      <h3 className="statHeaderQuality">quality</h3>
                      <Row>
                        <Col className="statLabel">minimum</Col>
                        <Col className="statLabel">maximum</Col>
                        <Col className="statLabel">average</Col>
                      </Row>
                      {this.renderQualityValues()}
                    </Col>
                  </Row>
                </Col>

              </Row>
            </Container>
          </div>
        </div>
      </div>
    );
  }

  renderHoursValues() {
    if (isNaN(this.state.sleepDurationAvg)) {
      return (
        <Row>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
        </Row>
      );
    }
    else {
      return (
        <Row>
          <Col className="statValue">{this.state.sleepDurationMin}</Col>
          <Col className="statValue">{this.state.sleepDurationMax}</Col>
          <Col className="statValue">{this.state.sleepDurationAvg}</Col>
        </Row>
      );
    }
  }

  renderQualityValues() {
    if (isNaN(this.state.sleepQualityAvg)) {
      return (
        <Row>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
        </Row>
      );
    }
    else {
      return (
        <Row>
          <Col className="statValue">{this.state.sleepQualityMin}</Col>
          <Col className="statValue">{this.state.sleepQualityMax}</Col>
          <Col className="statValue">{this.state.sleepQualityAvg}</Col>
        </Row>
      );
    }
  }

  renderStatValues() {
    if (isNaN(this.state.sleepQualityAvg) && isNaN(this.state.sleepDurationAvg)) {
      return (
        <Row>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
          <Col className="statValue">-</Col>
        </Row>
      );
    }
    else {
      return (
        <Row>
          <Col className="statValue">{this.state.sleepDurationMin}</Col>
          <Col className="statValue">{this.state.sleepDurationMax}</Col>
          <Col className="statValue">{this.state.sleepDurationAvg}</Col>
          <Col className="statValue">{this.state.sleepQualityMin}</Col>
          <Col className="statValue">{this.state.sleepQualityMax}</Col>
          <Col className="statValue">{this.state.sleepQualityAvg}</Col>
        </Row>
      );
    }
  }

  renderSleepChart(chartState, data) {
    if (this.state.isLoading === true) {
      return (
        <div className="chartPlaceholder">
          <h1>
            <FaCircleNotch className="spinning loadingChart" />
          </h1>
        </div>
      )
    }
    else if (data !== undefined && data.length > 0 && data[0].data.length > 0 && !isNull(data[0].data[0].y)) {
      return (
        <div>
          <div className="aboveChart">
            {this.renderChartLabel()}
          </div>
          <div className="chartContainer">
            <this.currentChartState currentState={chartState} currentData={data}></this.currentChartState>
          </div>
        </div>
      )
    }
    else {
      return (
        <div>
          <div className="aboveChart">
            <p className="chartAlert">No data for this week</p>
            {this.renderChartLabel()}
          </div>
          <div className="chartContainer">
            <this.currentChartState currentState={chartState} currentData={data}></this.currentChartState>
          </div>
        </div>
      );
    }
  }

  renderChartLabel() {
    if (!isUndefined(this.state.weekNum) || !isUndefined(this.state.monthNum) || !isUndefined(this.state.yearNumber)) {
      switch (this.state.chartState) {
        case "week":
          return (<p className="chartLabel">week {this.state.weekNum}</p>);
        case "month":
          return (<p className="chartLabel">{this.state.monthNames[this.state.monthNum]}</p>);
        case "year":
          return (<p className="chartLabel">{this.state.year}</p>);
        default:
          return (<p></p>);
      }
    }
    else {
      return (<p></p>);
    }
  }

  leftClick() {
    if (this.state.chartState === "week") {
      let prevWeekNum = this.state.weekNum - 1
      this.setState({ weekNum: prevWeekNum }, () => {
        this.filterSleepEntriesByWeek(this.state.sleepEntries, this.state.weekNum);
      })
    }
    else if (this.state.chartState === "month") {
      let prevMonthNum = this.state.monthNum - 1
      this.setState({ monthNum: prevMonthNum }, () => {
        this.filterSleepEntriesByMonth(this.state.sleepEntries, this.state.monthNum);
      })
    }
    else {
      let prevYearNum = this.state.year - 1
      this.setState({ year: prevYearNum }, () => {
        this.filterSleepEntriesByYear(this.state.sleepEntries, this.state.year);
      })
    }
  }

  rightClick() {
    if (this.state.chartState === "week") {
      let prevWeekNum = this.state.weekNum + 1
      this.setState({ weekNum: prevWeekNum }, () => {
        this.filterSleepEntriesByWeek(this.state.sleepEntries, this.state.weekNum);
      })
    }
    else if (this.state.chartState === "month") {
      let prevMonthNum = this.state.monthNum + 1
      this.setState({ monthNum: prevMonthNum }, () => {
        this.filterSleepEntriesByMonth(this.state.sleepEntries, this.state.monthNum);
      })
    }
    else {
      let prevYearNum = this.state.year + 1
      this.setState({ year: prevYearNum }, () => {
        this.filterSleepEntriesByYear(this.state.sleepEntries, this.state.year);
      })
    }
  }

  weekClick() {
    this.filterSleepEntriesByWeek(this.state.sleepEntries, this.state.weekNum);
  }

  monthClick() {
    this.filterSleepEntriesByMonth(this.state.sleepEntries, this.state.monthNum);
  }

  yearClick() {
    this.filterSleepEntriesByYear(this.state.sleepEntries, this.state.year);
  }

  currentChartState(props) {
    switch (props.currentState) {
      case "week":
        return <WeekChart sleepData={props.currentData}></WeekChart>;
      case "month":
        return <MonthChart sleepData={props.currentData}></MonthChart>;
      case "year":
        return <YearChart sleepData={props.currentData}></YearChart>;
      default:
        return <WeekChart sleepData={props.currentData}></WeekChart>;
    }
  }

  validRightBtn() {

    if (this.state.data.length > 0) {
      let currentDataLast = this.state.data[0].data[this.state.data[0].data.length - 1].x
      return (this.state.lastDay <= currentDataLast)
    }
    else {
      return true;
    }
  }

  validLeftBtn() {
    if (this.state.data.length > 0) {
      let currentDataFirst = this.state.data[0].data[0].x
      return (this.state.firstDay >= currentDataFirst);
    }
    else {
      return true;
    }
  }

  render() {
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderSleepEntries() : this.renderLander()}
      </div>
    );
  }
}
